<template>
  <div 
    class="opple-ota-card"
  >
    <div 
      class="opple-ota-card_head"
    >
      <span v-if="tianMu" style="color:#2481ea">{{ deviceModel?.DeviceName }}</span>
      <span>{{ status.text }}</span>
    </div>
    <div
      class="opple-ota-card_main"
    >
      <ul>
        <li v-if="type === 2">
          {{ $t('deviceMsg.firmwareNo') }}: <span>{{ info.SourceType || 0 }}</span>
        </li>
        <li>
          {{ $t('deviceMsg.currentversion') }}: 
          <span>{{ info.LocalVersion }}</span>
          <span v-if="info.isLasted "> ({{ $t('deviceMsg.uptodate') }})</span>
        </li>
        <li>{{ $t('deviceMsg.newversion') }}: <span>{{ info.LatestedVersion }}</span></li>
      </ul>
      <div
        v-if="isGattOtaOnly"
        class="opple-ota-card_warn"
      >
        {{ $t('otaUpdate.webMeshOtaNotSupported') }}
      </div>
    </div>
    <div
      class="opple-ota-card_foot"
    >
      <OtaProgress
        v-if="isShowOtaBtn" 
        :ota-status="info.otaStatus"
        :has-error="info.hasError"
        :progress="info.progress"
        :ota-info="info.otaInfo"
      />
      <div v-if="isShowOtaBtn" class="opple-ota-card_foot_btn">
        <OppleAuth
          v-if="status.isShowStartBtn "
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            :disabled="disabledBoot || status.isStartDisabled || isGattOtaOnly"
            :loading="isLoadingReqOta"
            @click="startOta"
          >
            {{ $t('deviceMsg.uplevel') }}
          </OppleButton>
        </OppleAuth>
        <OppleAuth
          v-if="status.isShowCancelBtn"
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            type="default"
            :loading="isLoadingReqCancelOta"
            @click="stopOta"
          >
            {{ $t('sync.close') }}
          </OppleButton>
        </OppleAuth>
      </div>
    </div>
  </div>
</template>
<script>
import OppleButton from '@/components/Base/OppleButton/index.vue'
import OtaProgress from './OtaProgress.vue';
import {
  StartOta
} from '@/axios/IDevice.js'
import { alerterror, alertsuccess, success, warning ,error } from '@/assets/js/common.js'
import { OTA_STATUS_ENUMS } from './enums';

const GATT_OTA_ONLY_SKUS = ['0010051a', '0010051b'];
const MIN_MESH_OTA_VERSION = '2.4.1';

export default {
  components: { 
    OppleButton,
    OtaProgress
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },

    otaStatus: {
      type: Number,
      default: 0
    },
  
    deviceModel: {
      type: Object,
      default: () => ({})
    },

    type: {
      type: Number,
      default: 1, // 1:单卡片 2:多卡片
    },

    upOtaIndex: {
      type: Number,
      default: 0
    },

    isDisabledGuide: {
      type: Boolean,
      default: false
    },

    isLoadingReqOta: {
      type: Boolean,
      default: false
    },

    isLoadingReqCancelOta: {
      type: Boolean,
      default: false
    },
    //是否天幕设备
    tianMu:{
      type: Boolean,
      default: false
    },
    // 天幕ota是否显示升级按钮
    showKeyUp: {
      type: Boolean,
      default: true
    },
    cardIndex: {
      type: Number,
      default: 0
    },
    isShowOtaBtn: {
      type: Boolean,
      default: false
    }
    // deviceModel: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  data() {
    return {
      disabledBoot: false,
    }
  },

  computed: {
    isGattOtaOnly() {
      const sku = String(this.deviceModel.ClassSku || '').replace(/^0x/i, '').toLowerCase();
      return GATT_OTA_ONLY_SKUS.includes(sku) &&
        this.cardIndex === 0 &&
        this.compareVersion(this.info.LocalVersion, MIN_MESH_OTA_VERSION) < 0;
    },
    status() {
      // const text = this.info.isLasted ? 
      //   this.$t('deviceMsg.newversion') : this.$t('deviceMsg.canUpgradeingMaster');
      const text = `${this.$t('otatask.firmware')}${this.cardIndex + 1}`;
      // console.log('this.info.otaStaus', this.info.otaStatus);

      if (this.info.LatestedVersion === '-') {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: false,
          isShowCancelBtn: false
        }
      }

      if (this.type === 0) {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: true,
          isShowCancelBtn: false
        }
      }

      // 已经是最新的
      if (this.info.isLasted) {
        return {
          text,
          isShowStartBtn: false, // 有一个升级就都不展示
          isStartDisabled: true,
          isShowCancelBtn: false
        }
      }

      // 非最新
      // 在线可升级
      if (!this.deviceModel.IsOnline) {
        return {
          text, // this.$t('otaUpdate.offline'), // this.$t('deviceMsg.uptodate')
          isShowStartBtn: false,
          isStartDisabled: false,
          isShowCancelBtn: false
        }
      };

      console.log('this.info.LatestedVersion', this.info.LatestedVersion);

      const isShowStartBtn = [
        OTA_STATUS_ENUMS.PADDING, 
        OTA_STATUS_ENUMS.STOP, 
        // OTA_STATUS_ENUMS.UPDATE_FAILED
      ].includes(this.otaStatus);

      // const isShowCancelBtn = [
      //   OTA_STATUS_ENUMS.PROCESSING,
      // ].includes(this.otaStatus);
      
      const isShowCancelBtn = this.info.otaStatus === OTA_STATUS_ENUMS.PROCESSING;

      return {
        text,
        isShowStartBtn,
        isStartDisabled: this.isDisabledGuide,
        isShowCancelBtn
      }
    }
  },

  watch: {
    status:{
      handler(){
        this.$emit('showUpLevelBtn',this.status,this.upOtaIndex)
      },
      immediate:true
    }
  },

  created() {
   
  },
  mounted(){
    
  },

  methods: {
    compareVersion(version, targetVersion) {
      const parseVersion = value => String(value || '')
        .replace(/^v/i, '')
        .split('.')
        .map(item => Number(item) || 0);
      const current = parseVersion(version);
      const target = parseVersion(targetVersion);
      const maxLength = Math.max(current.length, target.length);

      for (let i = 0; i < maxLength; i++) {
        const currentNum = current[i] || 0;
        const targetNum = target[i] || 0;
        if (currentNum > targetNum) return 1;
        if (currentNum < targetNum) return -1;
      }

      return 0;
    },
    /* 
     * 开始执行ota升级 注册socket
     */
    startOta () {
      this.$emit('startOta', this.upOtaIndex);
    },

    stopOta() {
      this.$emit('stopOta', this.upOtaIndex);
    },

    showKeyUpBtn() {
        // 如果是天幕设备
        if(this.tianMu){
          return this.showKeyUp 
        }
       return true
    }
  }
}
</script>

<style lang="scss">
.opple-ota-card {
  display: inline-block;
  margin-right: 10px;
  border: 1px solid rgb(233, 236, 244);
  border-radius: 5px;
  min-width: 289px;
  font-size: 12px;
  text-align: left;
  &_head {
    min-height: 17px;
    padding: 16px 10px;
    background: rgb(248, 248, 248);
    border-bottom: 1px solid rgb(233, 236, 244);
    text-align: center;
  }

  &_main {
    padding: 10px 10px 6px;

    li {
      padding: 2px 0;
    }
  }

  &_warn {
    margin-top: 6px;
    color: #f56c6c;
    line-height: 18px;
  }

  &_foot {
    display: flex;
    min-height: 36.5px;
    justify-content: space-between;
    align-items: center;
    padding: 6px 11px;

    &_btn {
      display: flex;
      width: 75px;
      justify-content: flex-end;
    }
  }
}
</style>